import {
  Icon,
  NewTask,
  CopyTask,
  NormalModal,
  getTranslatedText,
  BackgroundIcon,
  AccessControl,
  isAuthorised,
  toast,
  ERROR_CODES,
  Tag,
  B1,
  CustomModal,
  Row,
  Column,
  getParsedCrudData,
  Loader,
  PSA_CONSTANTS,
  useActivityTracker,
  EventEmitterWithIndex,
  getCurrentUserHook
} from '@nile/components';
import { DeleteModal } from '@nile/projects/src/Components/Modals';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import {
  StatusHolder,
  TaskProgressHolder
} from '@nile/projects/src/Components/Elements';
import {
  Popover,
  Modal,
  Page,
  Heading,
  Button,
  DisplayText
} from '@superops/ui-design-system';
import { PROJECT_STATUSES } from '@nile/projects/src/Components/Cards/ProjectListItem';
import { Medal } from '@styled-icons/fa-solid';
import React, { useState, useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import {
  TicketClient,
  GET_TASK_LIST,
  DELETE_TASK,
  UPDATE_TASK,
  CREATE_MILESTONE_TASK,
  CREATE_TASKS
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { MoreVert } from '@styled-icons/material';
import {
  DELETE_MILESTONE,
  UPDATE_MILESTONE,
  GET_PROJECT
} from '@nile/projects/src/Graphql';
import {
  constructTaskObject,
  isUnauthorizedUserPresent,
  filterAttrs,
  excludeMembers
} from '@nile/projects/src/Utils';

import { useMutation, useQuery } from '@apollo/client';
import { TaskCard } from '@nile/projects/src/Components/Cards';
import { cloneDeep, isLength, pick } from 'lodash';
import { TextCell } from '@nile/projects/src/Components/Inputs';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { SuperSortable } from '@nile/components/src/SuperSortable/SuperSortable';
import { UPDATE_TASKS } from '@nile/graphql/src/Mutation/task';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const Field = styled.div`
  min-width: 100px;
  max-width: 250px;
  flex-grow: 1;
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .Superops-ButtonGroup {
    margin-top: 12px;
  }
  .opt {
    color: #000000;
    justify-content: flex-start;
    .Superops-Button.Superops-Button--plain {
      padding: 0 10px !important;
      margin: -5px 0;
      justify-content: flex-start;
      // color: inherit;
    }
    :hover {
      background-color: #0000000d;
    }
  }
`;

const MilestoneHeader = styled.div`
  display: flex;
  justify-content: space-between;

  .dragHandle {
    visibility: hidden;
  }

  &:hover .dragHandle {
    visibility: visible;
  }
`;

const MilestoneTaskStyles = styled.div`
  width: 100%;
  max-width: 800px;
  height: 100%;
  min-height: 80px;
`;

const MilestoneProgressCard = (props) => {
  const { intl, disableDrag } = props;
  const {
    name,
    status,
    completedTasks,
    totalTasks,
    overdueTasks,
    plannedTasks,
    inProgressTasks,
    blockedTasks,
    milestoneId
  } = props.milestone;

  const { projectId, loggedInUserRole, members, owner } = props.project;

  const projectContext = useContext(ProjectContext);

  const currentUser = getCurrentUserHook();

  const [tasks, setTasks] = useState([]);
  const { loading, error, data, refetch } = useQuery(GET_TASK_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'project.projectId',
              operator: 'is',
              value: projectId
            },
            {
              attribute: 'milestone.milestoneId',
              operator: 'is',
              value: milestoneId
            }
          ]
        },
        sort: [
          {
            attribute: 'taskOrder',
            order: 'ASC',
            emptyAtLast: true
          }
        ]
      }
    },
    onCompleted(newData) {
      if (newData?.getTasks) {
        setTasks(newData.getTasks.tasks);
      }
    }
  });

  const [editActive, setEditActive] = useState(false);

  const handleEditChange = useCallback(() => setEditActive(!editActive), [
    editActive
  ]);

  const [warningModal, setWarningModal] = useState(false);

  const [taskTemplates, setTaskTemplates] = useState([]);

  const isEditable = loggedInUserRole?.roleId === '6';

  const editModal = React.createRef();

  const [popoverActive, setPopoverActive] = useState(false);

  const [active, setActive] = useState(false);

  const handleChange = useCallback(() => setActive(!active), [active]);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((val) => !val),
    []
  );

  const delModal = React.createRef();

  const [sheetActive, setSheetActive] = useState(false);

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };

  const [isUpdatingTaskOrder, setIsUpdatingTaskOrder] = useState(false);

  const [updateTasks] = useMutation(UPDATE_TASKS);

  const isItProduct = useCheckIsItProduct();

  const presentMembers = members.map((member) => member.user.userId);
  presentMembers.push(owner.userId);

  const addTaskTemplatesHandler = (updatedTaskList) => {
    if (updatedTaskList?.length) {
      TicketClient.mutate({
        mutation: CREATE_TASKS,
        variables: { taskInput: updatedTaskList }
      })
        .then((res) => {
          if (res?.data?.createTasks) {
            const updatedTasks = [...cloneDeep(tasks), ...res.data.createTasks];
            // updatedTasks.push(res.data.createTask);
            setTasks(updatedTasks);
            TicketClient.query({
              query: GET_PROJECT,
              variables: { projectId: props.project.projectId, isItProduct },
              fetchPolicy: 'network-only'
            }).then((resp) => {
              if (resp?.data?.getProject) {
                props.setProject(resp.data.getProject);
                toast('success', 'Tasks added successfully');
                setTaskTemplates([]);
                setWarningModal(false);
              }
            });
          }
        })
        .catch((err) => {
          // if (
          //   err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode
          // ) {
          //   toast(
          //     'error',
          //     <FormattedMessage
          //       id={
          //         ERROR_CODES[
          //           err.graphQLErrors[0].extensions.clientError[0].errorCode
          //         ]
          //       }
          //     />
          //   );
          // } else {
          //   // toast('error', 'Something went wrong');
          // }
        });
    }
  };

  const updateContext = (type, taskList) => {
    if (type === 'taskTemplateList') {
      let updatedTaskList = taskList.map((task) => {
        const { taskTemplateId, ...rest } = task;
        rest.project = {
          projectId: projectId
        };
        rest.milestone = {
          milestoneId: milestoneId
        };
        rest.technician = filterAttrs(rest.technician);
        return rest;
      });
      if (isUnauthorizedUserPresent(presentMembers, updatedTaskList)) {
        updatedTaskList = excludeMembers(presentMembers, updatedTaskList);
        setTaskTemplates(updatedTaskList);
        setWarningModal(true);
      } else {
        addTaskTemplatesHandler(updatedTaskList);
        setTaskTemplates(updatedTaskList);
      }
    }
  };

  const context = {
    value: {
      addTaskTemplateList: [],
      removeTaskTemplateList: [],
      taskTemplateList: [],
      selectedTaskTemplates: []
    },
    updateContext: updateContext
  };

  const activator = (
    <Button
      onClick={togglePopoverActive}
      plainSecondary
      icon={<SVGIcon name="Add" />}
    />
  );

  const handleUpdate = (property, value) => {
    TicketClient.mutate({
      mutation: UPDATE_MILESTONE,
      variables: {
        milestoneId: milestoneId,
        input: { milestoneId, [property]: value }
      }
    })
      .then((res) => {
        if (res?.data?.updateMilestone) {
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast('success', 'Milestone updated successfully');
              props.setProject(resp.data.getProject);
            }
          });
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const handleTaskDeletion = (id) => {
    TicketClient.mutate({
      mutation: DELETE_TASK,
      variables: { taskId: id, module: 'PROJECT' }
    })
      .then((res) => {
        if (res?.data?.deleteTask) {
          const updatedTasks = tasks
            .filter((task) => task.taskId !== id)
            .map((t, i) => ({ ...t, taskOrder: i + 1 }));
          setTasks(updatedTasks);

          const { updatedItems } = getParsedCrudData(
            tasks,
            updatedTasks.map((t, i) => ({ ...t, taskOrder: i + 1 })),
            'taskId'
          );

          setIsUpdatingTaskOrder(true);
          updateTasks({
            variables: {
              input: {
                workItem: { workId: projectId, module: 'PROJECT' },
                tasks: updatedItems.map((task) =>
                  pick(task, ['taskId', 'taskOrder'])
                )
              }
            }
          }).finally(() => {
            setIsUpdatingTaskOrder(false);
          });

          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast(
                'success',
                getTranslatedText(intl, 'ticket.details.task.delete.success')
              );
              props.setProject(resp.data.getProject);
            }
          });
          EventEmitterWithIndex.dispatch('refetchTimerEntries');
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const handleTaskUpdation = (id, task) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: { taskId: id, module: 'PROJECT', input: taskObj }
    })
      .then((res) => {
        if (res?.data?.updateTask) {
          const updatedTasks = cloneDeep(tasks);
          const idx = updatedTasks.findIndex((tsk) => tsk.taskId === id);
          updatedTasks[idx] = res.data.updateTask;
          setTasks(updatedTasks);
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast('success', 'Task updated successfully');
              props.setProject(resp.data.getProject);
            }
          });
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const handleDelete = () => {
    TicketClient.mutate({
      mutation: DELETE_MILESTONE,
      variables: {
        milestoneId: milestoneId
      }
    })
      .then((res) => {
        if (res?.data?.deleteMilestone) {
          props.handleUpdate('deleteMilestone', milestoneId);
          toast('success', 'Milestone deleted successfully');
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const handleTaskAddition = (type, task) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: CREATE_MILESTONE_TASK,
      variables: {
        ...taskObj,
        milestone: {
          milestoneId: props.milestone.milestoneId,
          name: props.milestone.name
        },
        project: {
          projectId
        }
      }
    })
      .then((res) => {
        if (res?.data?.createTask) {
          const updatedTasks = cloneDeep(tasks);
          updatedTasks.push(res.data.createTask);
          setTasks(updatedTasks);
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast('success', 'Task created successfully');
              props.setProject(resp.data.getProject);
              setSheetActive(!sheetActive);
            }
          });
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const isMilestoneDeleteAuthorized = isAuthorised(
    projectContext.features,
    'milestone.delete'
  );

  // const isMilestoneEditAuthorized = isAuthorised(
  //   projectContext.features,
  //   'milestone.edit'
  // );

  // const isTaskCreateAuthorized = isAuthorised(
  //   projectContext.features,
  //   'task.add'
  // );

  const deleteMilestone = isMilestoneDeleteAuthorized && (
    <div
      className="visibilityActions mr10 ml-10 cursor-pointer"
      ref={delModal}
      onClick={handleChange}
    >
      <SVGIcon name="Delete" color="#D90000" />
    </div>
  );

  return (
    <div
      className={`actr full-width ${isUpdatingTaskOrder && 'disable-actions'}`}
    >
      <div className="br10">
        <Column gap={10}>
          <MilestoneHeader className="visibilityContainer">
            <Row className="actr full-width" gap={5}>
              {disableDrag ? (
                <div className="pl20" />
              ) : (
                <SuperSortable.DragHandle className="dragHandle" />
              )}
              <div data-qa="projectMilestone">
                <Heading element="h3">
                  {/*  <DisplayText element="div" size="extraLarge" weight="Medium"> */}
                  <B1>
                    <AccessControl
                      reference={projectContext.features}
                      roleToCheck="milestone.edit"
                      render={
                        <TextCell
                          value={name}
                          handleUpdate={handleUpdate}
                          property="name"
                          editable={isEditable}
                          className="ellipsis mw200"
                        />
                      }
                      fallback={<div className="ellipsis mw200">{name}</div>}
                    />
                  </B1>
                </Heading>
              </div>
              <TaskProgressHolder
                completed={completedTasks}
                total={totalTasks}
                overdue={overdueTasks}
                open={plannedTasks}
                progress={inProgressTasks}
                blocked={blockedTasks}
                onlyProgressBar
              />
            </Row>
            {deleteMilestone}
            {isAuthorised(projectContext.features, 'task.add') && (
              <div
                className="options"
                data-qa="milestoneOptions"
                className="mr-10"
              >
                <Popover
                  active={popoverActive}
                  activator={activator}
                  onClose={togglePopoverActive}
                  preferredAlignment="right"
                >
                  <Field>
                    <AccessControl
                      reference={projectContext.features}
                      roleToCheck="task.add"
                      render={
                        <>
                          <div
                            data-qa="addMilestoneTaskBtn"
                            className="opt full-width"
                          >
                            <Button
                              onClick={toggleSheetActive}
                              plain
                              monochrome
                              fullWidth
                              icon={<SVGIcon name="Tasks" />}
                            >
                              <FormattedMessage id="project.details.milestone.addTask" />
                            </Button>
                          </div>
                          <AccessControl
                            reference={projectContext.features}
                            roleToCheck="taskTemplate.view"
                            render={
                              <div
                                data-qa="addMilestoneTaskTemplateBtn"
                                className="opt full-width"
                              >
                                <CopyTask
                                  tasksList={
                                    props?.taskTemplates?.getTaskTemplateList
                                  }
                                  context={context}
                                  name={getTranslatedText(
                                    intl,
                                    'project.details.milestone.templates'
                                  )}
                                  hideIcon
                                  icon={<SVGIcon name="Tasks" />}
                                  isLink
                                />
                              </div>
                            }
                          />
                        </>
                      }
                    />
                  </Field>
                </Popover>
              </div>
            )}
          </MilestoneHeader>
          <Row gap={15} className="pl20">
            <DisplayText element="span" size="medium" weight="Regular">
              <FormattedMessage
                id="project.milestone.planned"
                values={{ count: plannedTasks }}
              />
            </DisplayText>
            <DisplayText element="span" size="medium" weight="Regular">
              <FormattedMessage
                id="project.milestone.inProgress"
                values={{ count: inProgressTasks }}
              />
            </DisplayText>
            <DisplayText element="span" size="medium" weight="Regular">
              <FormattedMessage
                id="project.milestone.blocked"
                values={{ count: blockedTasks }}
              />
            </DisplayText>
          </Row>
        </Column>

        <MilestoneTaskStyles>
          {loading ? (
            <div className="pt-30">
              <Loader />
            </div>
          ) : (
            <SuperSortable
              onDragEnd={(reorderedList) => {
                const newList = reorderedList.map((task, index) => ({
                  ...task,
                  taskOrder: index + 1
                }));

                const { updatedItems } = getParsedCrudData(
                  tasks,
                  newList,
                  'taskId'
                );

                setTasks(newList);

                if (!updatedItems.length) return;

                // eslint-disable-next-line react-hooks/rules-of-hooks
                useActivityTracker({
                  event:
                    PSA_CONSTANTS.MIX_PANEL_EVENTS_FOR_REORDER.PROJECT_DETAILS
                      .TASK
                });

                setIsUpdatingTaskOrder(true);
                updateTasks({
                  variables: {
                    input: {
                      workItem: { workId: projectId, module: 'PROJECT' },
                      tasks: updatedItems.map((task) =>
                        pick(task, ['taskId', 'taskOrder'])
                      )
                    }
                  }
                }).finally(() => {
                  setIsUpdatingTaskOrder(false);
                });
              }}
              list={tasks}
            >
              {tasks.map((task) => {
                const enableView =
                  ['6', '7'].includes(props.project.loggedInUserRole?.roleId) ||
                  currentUser?.userId === task?.technician?.userId;
                return (
                  <TaskCard
                    task={task}
                    module="PROJECT_TASK"
                    details={
                      task?.taskId
                        ? {
                            operation: 'UPDATE',
                            projectId: props?.project?.projectId,
                            taskId: task?.taskId
                          }
                        : {
                            operation: 'CREATE',
                            projectId: props?.project?.projectId
                          }
                    }
                    handleTaskDeletion={handleTaskDeletion}
                    handleTaskUpdation={handleTaskUpdation}
                    index={task.taskId}
                    enableDrag={isAuthorised(
                      projectContext.features,
                      'task.edit'
                    )}
                    disableEdit={
                      !isAuthorised(projectContext.features, 'task.edit')
                    }
                    disableView={!enableView}
                    disableDelete={
                      !isAuthorised(projectContext.features, 'task.delete')
                    }
                  />
                );
              })}
            </SuperSortable>
          )}
        </MilestoneTaskStyles>

        <DeleteModal
          description={getTranslatedText(
            intl,
            'project.details.milestone.delete.desc'
          )}
          handleDeleteConfirmation={handleDelete}
          title={getTranslatedText(
            intl,
            'project.details.milestone.delete.text'
          )}
          reference={delModal}
          active={active}
          handleChange={handleChange}
        />
        <NewTask
          addOrUpdateTechGroup={handleTaskAddition}
          state={sheetActive}
          toggleSheetActive={toggleSheetActive}
          name={getTranslatedText(intl, 'project.details.milestone.addTask')}
          hideIcon
          isLink
          noRender
          module="PROJECT_TASK"
          details={
            props?.data?.taskId
              ? {
                  operation: 'UPDATE',
                  projectId: props?.project?.projectId,
                  taskId: props?.data?.taskId
                }
              : {
                  operation: 'CREATE',
                  projectId: props?.project?.projectId
                }
          }
        />

        <NormalModal
          isOpen={warningModal}
          toggleOpen={setWarningModal}
          title={getTranslatedText(
            intl,
            'project.details.actions.templateWarnings'
          )}
          primaryBtn={getTranslatedText(intl, 'common.confirm')}
          secondaryBtn={getTranslatedText(intl, 'common.cancel')}
          primaryAction={() => addTaskTemplatesHandler(taskTemplates)}
          description={getTranslatedText(intl, 'project.details.actions.desc')}
        />
      </div>
    </div>
  );
};

export default injectIntl(MilestoneProgressCard);
